const UruguaySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112711)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 14.7829H39.311C38.8095 12.9224 38.0473 11.1692 37.0645 9.56543H20V14.7829Z"
        fill="#338AF3"
      />
      <path
        d="M7.5508 35.652H32.4503C34.2755 34.1982 35.8408 32.4325 37.065 30.4346H2.93604C4.16033 32.4324 5.72564 34.1982 7.5508 35.652Z"
        fill="#338AF3"
      />
      <path d="M20 0V4.34781H32.4498C29.0334 1.62688 24.707 0 20 0Z" fill="#338AF3" />
      <path
        d="M20 14.7809H39.311C38.8095 12.9204 38.0473 11.1672 37.0645 9.56348H20V14.7809Z"
        fill="#338AF3"
      />
      <path
        d="M0 20C0 21.8052 0.240625 23.5538 0.688984 25.2174H39.3111C39.7594 23.5538 40 21.8052 40 20H0Z"
        fill="#338AF3"
      />
      <path
        d="M17.3915 11.7059L14.9488 12.8549L16.2495 15.2205L13.5972 14.7132L13.2611 17.3925L11.4138 15.4219L9.56627 17.3925L9.23025 14.7132L6.57791 15.2204L7.87854 12.8548L5.43604 11.7059L7.87861 10.5571L6.57791 8.19148L9.23018 8.69883L9.56635 6.01953L11.4138 7.99016L13.2612 6.01953L13.5972 8.69883L16.2496 8.19148L14.9489 10.5572L17.3915 11.7059Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112711">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UruguaySvg;
